import StorageUtil from '../../core/util/storage_util';

/// ローカルストレージ大業パまとめ買い表非表示キー論理名
const HIDE_COMMERCIAL_PACK_KEY = 'HIDE_COMMERICAL_PACK_TABLE';
/// ローカルストレージ大業パまとめ買い表非表示の設定値
const HIDE_COMMERCIAL_PACK_VALUE = '1';
/// 大業パまとめ買いお得価格エリアの有効日数
const LOCAL_COMMERCIAL_PACK_DATE_LIMIT = 30;

export class LargeCommercialPack {
  /// 大業パまとめ買い表の初期表示を設定する
  static checkCommercialPackList() {
    const commercialPackList = document.getElementById('commercialPackList') as HTMLInputElement;
    if (commercialPackList === null) return;
    const hideCommercialPackValue = StorageUtil.getItemWithExpiration(HIDE_COMMERCIAL_PACK_KEY);

    if (hideCommercialPackValue === HIDE_COMMERCIAL_PACK_VALUE) {
      /// 大業パまとめ買い表を非表示にする
      commercialPackList.style.display = 'none';
      /// チェックボックスのチェックを有効にする
      const checkBox = document.getElementById('hideCommercialPackCheckbox') as HTMLInputElement;
      checkBox.checked = true;
    } else {
      /// 大業パまとめ買い表を非表示にする
      commercialPackList.style.display = 'block';
    }
  }

  /// 大業パまとめ買い表の一定期間表示しないチェックボックス選択時ローカルストレージに選択状況を更新する
  static changeCommercialPackCheckbox() {
    const checkBox = document.getElementById('hideCommercialPackCheckbox') as HTMLInputElement;
    /// 大業パまとめ買い表の一定期間表示しないにチェックを入れたとき
    if (checkBox.checked) {
      /// ローカルストレージに非表示の値を更新する
      StorageUtil.setItemAfterDates(
        HIDE_COMMERCIAL_PACK_KEY,
        HIDE_COMMERCIAL_PACK_VALUE,
        LOCAL_COMMERCIAL_PACK_DATE_LIMIT
      );
      /// 大業パまとめ買い表の一定期間表示しないからチェックを外した時
    } else if (!checkBox.checked) {
      /// ローカルストレージから大業パまとめ買い表非表示を削除する
      localStorage.removeItem(HIDE_COMMERCIAL_PACK_KEY);
    }
  }
}
